import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import DateSelector from "../../Common/DateSelector";
import { Loader } from "../../Common/Loader";
import TimeSelector from "../../Common/TimeSelector";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { getAssistantList } from "../../Redux/Slice/Assistant/AssistantsListSlice";
import { ScheduleCallForContact } from "../../Redux/Slice/Contacts/ScheduleCallSlice";
import PlusIconBtn from "../../Common/PlusIconBtn";
import ReactQuillEditor from "../../Common/ReactQuillEditor";
import AddVariableModal from "../../Model/AddVariableModal";
import { scheduleEmail } from "../../Redux/Slice/Contacts/Email/ScheduleEmailSlice";
import { scheduleCallAction } from "../../Redux/Slice/Contacts/CallActionSlice";
import { scheduleFormCallAction } from "../../Redux/Slice/Contacts/FormCallActionSlice";

export const ScheduleEmailPopup = (props) => {
  const dispatch = useDispatch();
  const [formData, setFormdata] = useState({
    emailDate: "",
    startTime: "",
    assistant: "",
    assistantId: "",
    subject: "",
    description: "",
  });
  const [formError, setFormError] = useState({
    dateError: "",
    timeError: "",
  });
  const [assistants, setAssistants] = useState([]);
  const AssistantList = useSelector((state) => state.assistants.assistantsList);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isToday, setIsToday] = useState(false);
  const [addVariableModalVisible, setAddVariableModalVisible] = useState({
    variableFor: null,
    visible: false,
  });

  useEffect(() => {
    FetchAssistantsList();
  }, []);

  const FetchAssistantsList = async () => {
    const result = await dispatch(
      getAssistantList({ text: "", isDropdown: true })
    );
  };
  useEffect(() => {
    if (AssistantList) {
      setAssistants(AssistantList.data);
    }
  }, [AssistantList]);

  function compareTimes(time1, time2) {
    const parseTime = (time) => {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);

      return hours * 60 + minutes; // Return total minutes
    };

    const totalMinutes1 = parseTime(time1);
    const totalMinutes2 = parseTime(time2);

    if (totalMinutes1 < totalMinutes2) {
      return true;
    } else {
      return false;
    }
  }

  const compareDate = (val1, val2) => {
    if (
      val1.getDate() === val2.getDate() &&
      val1.getMonth() === val2.getMonth() &&
      val1.getFullYear() === val2.getFullYear()
    ) {
      return true;
    } else {
      return false;
    }
  };
  function compareCurrentTime(givenTime) {
    // Get the current date and time
    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const [givenHours, givenMinutes] = givenTime.split(":").map(Number);
    if (
      currentHours > givenHours ||
      (currentHours === givenHours && currentMinutes > givenMinutes)
    ) {
      return true;
    } else if (
      currentHours < givenHours ||
      (currentHours === givenHours && currentMinutes < givenMinutes)
    ) {
      return false;
    } else {
      return false;
    }
  }
  const dateUTCFormat = (date, time) => {
    const localDateTime = moment(`${date} ${time}`, "DD/MM/YYYY HH:mm");
    const utcDateTime = localDateTime.utc().format();
    return utcDateTime;
  };

  const handleChange = (e) => {
    let { value, name } = e.target;
    setFormdata({ ...formData, [name]: value });
    if (name === "emailDate") {
      let errors = formError;
      setFormdata({ ...formData, [name]: dateFormat(value) });
      if (compareDate(new Date(value), new Date())) {
        setIsToday(true);
        errors = {
          ...formError,
          dateError: "",
        };
        if (formData.startTime != "") {
          if (compareCurrentTime(formData.startTime)) {
            errors = {
              ...formError,
              timeError: "Start Time cannot be less than now.",
            };
          } else {
            errors = {
              ...formError,
              timeError: "",
            };
          }
        }
      } else if (new Date(value) < new Date()) {
        setIsToday(false);
        errors = {
          ...formError,
          dateError: "Call Date cannot be in the past.",
        };
      } else {
        setIsToday(false);
        errors = {
          ...formError,
          dateError: "",
        };
      }
      if (formData.startTime) {
        const isTodayDate = moment(value, "DD/MM/YYYY").isSame(
          moment(),
          "date"
        );
        if (isTodayDate) {
          if (compareCurrentTime(formData.startTime)) {
            errors = {
              ...formError,
              timeError: "Start Time cannot be less than now.",
            };
          } else {
            errors = {
              ...formError,
              timeError: "",
            };
          }
        } else {
          errors = {
            ...formError,
            timeError: "",
          };
        }
      }
      setFormError(errors);
    } else if (name === "startTime") {
      const isTodayDate =
        isToday ||
        moment(formData.emailDate, "DD/MM/YYYY").isSame(moment(), "date");
      if (isTodayDate) {
        if (compareCurrentTime(value)) {
          setFormError({
            ...formError,
            timeError: "Start Time cannot be less than now.",
          });
        } else {
          setFormError({
            ...formError,
            timeError: "",
          });
        }
      }
    } else if (name === "assistantId") {
      const assistant = assistants.find((x) => x.id === value);
      if (assistant) {
        setFormdata((prev) => ({
          ...prev,
          subject: assistant?.email?.subject || "",
          description: assistant?.email?.description || "",
          assistant: assistant.name,
          [name]: value,
        }));
      } else {
        setFormdata({ ...formData, [name]: value, assistant: assistant.name });
      }
    } else if (name === "subject") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, subjectError: "" });
      } else {
        setFormError({
          ...formError,
          subjectError: "Subject must be between 3 and 100 characters long",
        });
      }
      setFormdata({
        ...formData,
        subject: value,
      });
    } else if (name === "description") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, descriptionError: "" });
      } else {
        setFormError({
          ...formError,
          descriptionError: "Message must be between 3 and 100 characters long",
        });
      }
      setFormdata({
        ...formData,
        description: value,
      });
    }
  };

  const handleCancel = (name) => {
    if (name === "emailDate") {
      setFormdata({ ...formData, emailDate: "" });
    } else if (name === "time") {
      setFormdata({ ...formData, startTime: "" });
    } else if (name === "assistant") {
      setFormdata({ ...formData, assistant: "", assistantId: "" });
    }
  };

  const onSubmitAddVariable = (variable) => {
    setFormdata((p) => ({
      ...p,
      [addVariableModalVisible.variableFor]:
        p[addVariableModalVisible.variableFor] == "string"
          ? p[addVariableModalVisible.variableFor] + variable
          : variable,
    }));
    setAddVariableModalVisible({
      visible: false,
      variableFor: null,
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const list = props.contactsList();
      let body = {
        date: dateUTCFormat(formData.emailDate, formData.startTime),
        emailTime: formData.startTime,
        subject: formData.subject,
        description: formData.description,
        assistantId: formData.assistantId,
      };
      if (props?.isForContactGroup) {
        body.contactGroupIds = list;
      } else if (props?.isForCallId) {
        body.callId = list;
        body.action = "scheduleEmail";
      } else if (props?.isForForm) {
        body.contacts = list;
        body.action = "scheduleCall";
      } else {
        body.contactIds = list;
      }

      const action = props?.isForCallId
        ? scheduleCallAction
        : props?.isForForm
        ? scheduleFormCallAction
        : scheduleEmail;
      const result = await dispatch(action(body));
      if (action.fulfilled.match(result) && result?.payload?.success === true) {
        props.closePopup("success");
        setIsLoading(false);
      } else {
        props.closePopup("error", result?.payload?.error);
        setIsLoading(false);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return errorModel ? (
    <ErrorModel message={errorMessage} />
  ) : successModel ? (
    <SuccessModel message={successMessage} />
  ) : addVariableModalVisible?.visible ? (
    <AddVariableModal
      assistantId={formData?.assistantId}
      onSubmit={onSubmitAddVariable}
      onClose={() =>
        setAddVariableModalVisible({
          variableFor: null,
          visible: false,
        })
      }
    />
  ) : (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--lg">
          <div className="modal__header">
            <h1 className="modal__header--title">Schedule a email</h1>
            <p className="para">
              <strong>Note:</strong> You are scheduling email with more than one
              assistant with different time slots.
            </p>
            <button
              className="btn btn__transparent btnClose"
              onClick={props.closePopup}
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.586914"
                  width="24"
                  height="24"
                  rx="12"
                  fill="#E5E5E5"
                />
                <path
                  d="M12.5869 10.8891L16.476 7L17.5869 8.11094L13.6979 12L17.5869 15.8891L16.476 17L12.5869 13.1109L8.69785 17L7.58691 15.8891L11.476 12L7.58691 8.11094L8.69785 7L12.5869 10.8891Z"
                  fill="#4F4F4F"
                />
              </svg>
            </button>
          </div>
          <div className="modal__body  modal-body-left">
            <div className="scheduleCall">
              <div className="scheduleCall__row scheduleCall__row--divider">
                <div className="form__Field">
                  <label for="emailDate" className="form__label">
                    Email Date<sup className="form__label__asterisk">*</sup>
                  </label>
                  {formData.emailDate === "" || formError.dateError != "" ? (
                    <DateSelector
                      name="emailDate"
                      value={formData.emailDate}
                      onChange={handleChange}
                      placeholder="DD/MM/YYYY"
                      minDate={moment()}
                    />
                  ) : (
                    <div className="btn__group">
                      <button className="btnScheduleCall btnScheduleCall--success">
                        {formData.emailDate}
                        <div onClick={() => handleCancel("emailDate")}>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.5 3.50016L8.00016 0L9 0.999843L5.49984 4.5L9 8.00016L8.00016 9L4.5 5.49984L0.999843 9L0 8.00016L3.50016 4.5L0 0.999843L0.999843 0L4.5 3.50016Z"
                              fill="#4F4F4F"
                            />
                          </svg>
                        </div>
                      </button>
                    </div>
                  )}
                  <div className="form__error">{formError.dateError}</div>
                </div>
                <div className="form__Field">
                  <label for="callTime" className="form__label">
                    Email Time<sup className="form__label__asterisk">*</sup>
                  </label>
                  {formData.startTime === "" || formError.timeError != "" ? (
                    <>
                      {" "}
                      <TimeSelector
                        type="time"
                        id="callTime"
                        name="startTime"
                        value={formData.startTime}
                        onChange={handleChange}
                        placeholder="00:00"
                      />
                      <div className="form__error">{formError.timeError}</div>
                    </>
                  ) : (
                    <div className="btn__group">
                      <button className="btnScheduleCall">
                        {formData.startTime}
                        <div onClick={() => handleCancel("time")}>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.5 3.50016L8.00016 0L9 0.999843L5.49984 4.5L9 8.00016L8.00016 9L4.5 5.49984L0.999843 9L0 8.00016L3.50016 4.5L0 0.999843L0.999843 0L4.5 3.50016Z"
                              fill="#4F4F4F"
                            />
                          </svg>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
                <div className="form__Field">
                  <label for="assistant" className="form__label">
                    Assistant<sup className="form__label__asterisk">*</sup>
                  </label>
                  {formData.assistantId === "" ? (
                    <select
                      className="form__select form__select--sm"
                      id="assistant"
                      name="assistantId"
                      value={formData.assistantId}
                      onChange={handleChange}
                    >
                      <option selected="" value="" disabled>
                        -Select-
                      </option>
                      {assistants
                        ? assistants.map((assistant) => (
                            <option value={assistant.id}>
                              {assistant.name}
                            </option>
                          ))
                        : ""}
                    </select>
                  ) : (
                    <div className="btn__group">
                      <button className="btnScheduleCall btnScheduleCall--primary">
                        {/* <img src="/images/create-assistant-img01.jpg" alt="" /> */}
                        {formData.assistant}
                        <div onClick={() => handleCancel("assistant")}>
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 9 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.5 3.50016L8.00016 0L9 0.999843L5.49984 4.5L9 8.00016L8.00016 9L4.5 5.49984L0.999843 9L0 8.00016L3.50016 4.5L0 0.999843L0.999843 0L4.5 3.50016Z"
                              fill="#4F4F4F"
                            />
                          </svg>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="scheduleCall__row">
                <div className="form__Field form__Field--full">
                  <label
                    for="subject"
                    className="form__label form__label--flex"
                  >
                    <span>
                      Subject<sup className="form__label__asterisk">*</sup>
                    </span>
                    {formData.assistantId ? (
                      <PlusIconBtn
                        onClick={() =>
                          setAddVariableModalVisible({
                            variableFor: "subject",
                            visible: true,
                          })
                        }
                      />
                    ) : null}
                  </label>
                  <input
                    id="subject"
                    className="form__input form__input--sm"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject"
                    maxLength={100}
                  />
                  {formError?.subjectError ? (
                    <div className="form__error">{formError.subjectError}</div>
                  ) : null}
                </div>
              </div>
              <div className="scheduleCall__row">
                <div className="form__Field form__Field--full">
                  <label
                    for="description"
                    className="form__label form__label--flex"
                  >
                    <span>
                      Message<sup className="form__label__asterisk">*</sup>
                    </span>
                    {formData.assistantId ? (
                      <PlusIconBtn
                        onClick={() =>
                          setAddVariableModalVisible({
                            variableFor: "description",
                            visible: true,
                          })
                        }
                      />
                    ) : null}
                  </label>
                  <ReactQuillEditor
                    id="description"
                    name="description"
                    theme="snow"
                    value={formData.description}
                    style={{ width: "100%" }}
                    placeholder="Enter your message here..."
                    onChange={(value) => {
                      setFormdata({ ...formData, description: value });
                    }}
                  />
                  {formError?.descriptionError ? (
                    <div className="form__error">
                      {formError.descriptionError}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white" onClick={props.closePopup}>
                Cancel
              </button>
              <button
                className="btn btn__primary"
                disabled={
                  formData.emailDate === "" ||
                  formError.dateError != "" ||
                  formData.startTime === "" ||
                  formError.timeError != "" ||
                  formData.assistantId === "" ||
                  formData?.subject === "" ||
                  formError?.subjectError ||
                  formData?.description === "" ||
                  formError?.descriptionError
                }
                onClick={handleSubmit}
              >
                Schedule
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
